import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";
import SchemaFieldCategory from "@mapmycustomers/shared/enum/SchemaFieldCategory";

import { DEFAULT_EMPTINESS_OPERATOR } from "@app/util/filters/defaultFilters";
import EmptyFilter from "@app/util/filters/EmptyFilter";
import TextFilter, { TEXT_FILTER_OPERATORS } from "@app/util/filters/TextFilter";

import Field, { FieldProperties } from "./Field";
import { listFormatter } from "./fieldUtil";

class NotesField extends Field {
  constructor(data: Omit<FieldProperties, "type">) {
    super({
      customFilterConfig: {
        defaultInstance: "notes",
        filterInstances: {
          empty: EmptyFilter,
          notes: TextFilter,
        },
        operators: [...TEXT_FILTER_OPERATORS, ...DEFAULT_EMPTINESS_OPERATOR],
      },
      customGridProperties: {
        cellRenderer: "notesCellRenderer",
        // disable tooltips for this field, since we use custom renderer with a popover
        tooltipValueGetter: undefined,
      },
      extraPlatformFiltersGetter: () => ({ includeNotes: true }),
      features: [
        FieldFeature.NON_INTEGRATION,
        FieldFeature.NON_MAP_VIEW,
        FieldFeature.FILTERABLE,
        FieldFeature.FILTERABLE_ON_MAP,
        FieldFeature.NON_ADDABLE_FORM_FIELD,
      ],
      filterType: FieldType.STRING,
      platformFilterNames: ["notes.note"],
      type: FieldType.LIST,
      valueFormatter: listFormatter("note"),
      ...data,
    });
  }

  get platformFieldCategory() {
    return SchemaFieldCategory.NOTE;
  }
}

export default NotesField;
